import { Audience } from "@/types";

export const ADD_TO_COMPARE = "ADD_TO_COMPARE";
export const SET_COMPARE = "SET_COMPARE";
export const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";
export const CLEAR_COMPARE = "CLEAR_COMPARE";

export type CompareAction =
  | { type: typeof ADD_TO_COMPARE; payload: { audience: Audience, index?: number } }
  | { type: typeof SET_COMPARE; payload: Audience[] }
  | { type: typeof REMOVE_FROM_COMPARE; payload: Audience }
  | { type: typeof CLEAR_COMPARE }

/** The audiences selected for comparison. Their insights come from the query cache. */
export interface CompareState {
  comparisonAudiences: Audience[];
}

export const initialState: CompareState = {
  comparisonAudiences: [],
};
